import { JsonProperty } from 'typescript-json-serializer';

export class BalanceTransactionModel {
  @JsonProperty('Id') id: string;
  @JsonProperty('Amount') amount: number;
  @JsonProperty('Currency') currency: string;
  @JsonProperty('CreatedAt') created: Date;
  @JsonProperty('Description') description: string;
  @JsonProperty('ReportingCategory') reportingCategory: string;
  @JsonProperty('Status') status: string;
  @JsonProperty('Comment') comment: string;
  @JsonProperty('SourceId') sourceId: string;
  @JsonProperty('TransactionId') transactionId: string;
}
